import { render, staticRenderFns } from "./ReviewSkill.vue?vue&type=template&id=67b34f20&scoped=true&"
import script from "./ReviewSkill.vue?vue&type=script&lang=js&"
export * from "./ReviewSkill.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSkill.vue?vue&type=style&index=0&id=67b34f20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b34f20",
  null
  
)

export default component.exports